<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">优质主播池</h1>
    <div class="filter-section">
      <el-row :gutter="20" class="filter-row">
        <el-col :span="6">
          <div class="filter-item">
            <label class="filter-label">激活时间</label>
            <el-date-picker
              v-model="platformData"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="retainedOptions"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            >
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="filter-item">
            <label class="filter-label">国家</label>
            <el-select
              filterable
              v-model="country"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(item, itemIndex) in countryList"
                v-bind:key="itemIndex + 99"
                :label="item.country"
                :value="item.countryCode"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="filter-item">
            <label class="filter-label">渠道</label>
            <el-select
              filterable
              v-model="channel"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in channelList"
                :key="item.value || item.channelId || index"
                :label="item.name || item.channelName || item.value"
                :value="item.value || item.channel || item.channelName"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="filter-item">
            <label class="filter-label">考核评级</label>
            <el-select
              filterable
              v-model="assRating"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option label="total" value=""></el-option>
              <el-option value="A"></el-option>
              <el-option value="B"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="filter-item">
            <label class="filter-label">颜值标签</label>
            <el-select
              filterable
              v-model="labelId"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option label="total" :value="0"></el-option>
              <el-option
                v-for="(item, i) in faceValueList"
                :key="i"
                :label="item.labelName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="filter-row">
        <el-col :span="4">
          <div class="filter-item">
            <label class="filter-label">代理ID</label>
            <el-input v-model="agentId" placeholder="选填"></el-input>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="filter-item">
            <label class="filter-label">主播ID</label>
            <el-input v-model="rid" placeholder="选填"></el-input>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="filter-item button-group">
            <el-button type="warning" @click="getDayChatDetai" :loading="login1" size="medium">
              查询
            </el-button>
            <el-button type="success" @click="dwnDayChatDetai" :loading="login2" size="medium">
              下载
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width:100%;"
        v-loading="login1"
        height="80vh"
        stripe
        border
      >
        <el-table-column prop="index" fixed label="No" width="80">
        </el-table-column>

        <el-table-column prop="rid" fixed label="主播ID" width="180">
        </el-table-column>
        <el-table-column prop="head" fixed label="主播头像" width="180">
          <template slot-scope="scope">
            <el-image
              style="width: 180px; height: 180px"
              :src="scope.row.head"
              fit="contain"
              :preview-src-list="[scope.row.head]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="主播昵称" width="180">
        </el-table-column>
        <el-table-column prop="country" label="主播国家" width="180">
        </el-table-column>
        <el-table-column prop="agentName" label="代理名" width="180">
        </el-table-column>
        <el-table-column prop="agentId" label="代理id" width="180">
        </el-table-column>
        <el-table-column prop="activationTime" label="激活时间" width="180">
        </el-table-column>
        <el-table-column prop="mtime" label="通过考核时间" width="180">
        </el-table-column>
        <el-table-column prop="score" label="评分" width="180">
        </el-table-column>
        <el-table-column prop="assScore" label="考核得分" width="180">
        </el-table-column>
        <el-table-column prop="assRating" label="考核评级" width="180">
        </el-table-column>
        <el-table-column prop="level" label="主播等级" width="180">
          <template slot-scope="scope">
            {{ level_(scope.row.level) }}
          </template>
        </el-table-column>
        <el-table-column prop="income" label="过去24小时收入" width="180">
        </el-table-column>
        <el-table-column prop="answerRate" label="接听率" width="180">
        </el-table-column>
        <el-table-column prop="liveTime" label="live时长" width="180">
        </el-table-column>
        <el-table-column prop="exposureCtr" label="曝光点击率" width="180">
        </el-table-column>
        <el-table-column
          prop="unitCallDuration"
          label="单位时长收入"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="faceValueLabel" label="颜值标签" width="180">
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <div class="juzhong">
              <el-button
                type="primary"
                @click="adopt_reject(scope.row)"
                size="medium"
                >修改</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <div class="okay">
          <div>
            <span>rid:</span>
            <el-input
              style="width:150px"
              v-model="row.rid"
              placeholder="请输入内容"
            ></el-input>
          </div>
          <div>
            <span>level:</span>
            <el-select
              style="width:150px"
              v-model="row.level"
              placeholder="请选择"
            >
              <el-option
                v-for="item in levels"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

          <div>
            <span>备注:</span>
            <el-input
              type="textarea"
              :rows="2"
              style="width:150px"
              v-model="row.operatorDesc"
              placeholder="请输入内容"
            ></el-input>
          </div>
          <div>
            <span>时长(小时):</span>
            <el-input
              style="width:150px"
              v-model="row.hour"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="_gethostlevel">确 定</el-button>
        </span>
      </el-dialog>
    </el-row>
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
        :page-size="10"
      ></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
import { getChannelList } from '@/api/baseRequest'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      // 加载
      login1: false,
      login2: false,

      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      // 通话日期
      platformData: [datainfor(7), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],

      country: 'total',
      countryList: [],
      channel: '',
      channelList: [],
      agentId: '',
      rid: '',
      language: 'all',
      languageList: [],
      assRating: '',
      score: '',
      labelId: 0,
      row: {
        rid: '',
        level: '',
        operatorDesc: '',
        hour: ''
      },
      dialogVisible: false,
      levels: [
        {
          label: 'L0',
          value: 0
        },
        {
          label: 'L1',
          value: 1
        },
        {
          label: 'L2',
          value: 2
        },
        {
          label: 'L3',
          value: 3
        }
      ]
    }
  },
  computed: {
    ...mapState(['faceValueList'])
  },
  async created() {
    await this._getLanguage()
    this.getDayChatDetai()
    this._getCountry()
    this._getChannel()
  },
  methods: {
    level_(row) {
      let a = {
        0: 'L0',
        1: 'L1',
        2: 'L2',
        3: 'L3'
      }
      return a[row]
    },
    adopt_reject(row) {
      this.row = {
        rid: row.rid,
        level: row.level,
        operatorDesc: ''
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.$confirm('确认关闭？')
        .then(() => {
          this.row = {}
          this.dialogVisible = false
        })
        .catch(() => {})
    },
    async _gethostlevel() {
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.gethostlevel,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          rid: this.row.rid,
          level: this.row.level,
          hour: this.row.hour,
          hostType: 0,
          operatorDesc: this.row.operatorDesc
        }
      })
      if (res.data.code != 0) return this.$message(res.data.msg)
      this.$message.success(res.data.msg)
      this.getDayChatDetai()
      this.dialogVisible = false
    },
    async _getCountry() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async _getChannel() {
      const res = await getChannelList()
      this.channelList = [{ name: 'total', value: '' }, ...(res || [])]
    },
    async _getLanguage() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
        this.language = res[0].langCode
      }
    },
    // 查询列表
    async getDayChatDetai() {
      this.login1 = true
      if (this.platformData == null) {
        this.platformData = ['', '']
      }
      const { data: res } = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.quality_host_pool,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token
        },
        data: {
          start: this.platformData[0],
          end: this.platformData[1],
          page: this.page,
          countryCode: this.country,
          channel: this.channel,
          agentId: this.agentId,
          rid: this.rid,
          assRating: this.assRating,
          score: this.score,
          labelId: this.labelId
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      let newList = []
      res.data.data.map((e, i) => {
        newList.push({ index: i + 1 + (this.page - 1) * 10, ...e })
      })
      this.dayChatDetailData = newList
      this.total = res.data.total
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'post',
        url: this.$store.getters.path.quality_host_pool_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token
        },
        data: {
          start: this.platformData[0],
          end: this.platformData[1],
          page: -1,
          countryCode: this.country,
          channel: this.channel,
          agentId: this.agentId,
          rid: this.rid,
          assRating: this.assRating,
          score: this.score,
          labelId: this.labelId
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '优质主播池' + this.platformData[1])
    },
    // 分页
    handleCurrentChange() {
      this.getDayChatDetai()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .filter-section {
    margin-top: 20px;
    padding: 20px;
    background: #f5f7fa;
    border-radius: 4px;

    .filter-row {
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .filter-item {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .filter-label {
        font-size: 14px;
        color: #606266;
        font-weight: 500;
        white-space: nowrap;
      }

      &.button-group {
        flex-direction: row;
        align-items: flex-end;
        justify-content: flex-start;
        gap: 12px;
        padding-top: 8px;
      }
    }
  }

  .user-options {
    margin-top: 20px;

    .el-col {
      margin-bottom: 20px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
.okay {
  > div {
    display: flex;
    align-items: center;
    margin: 0 0 10px;
    > span {
      width: 100px;
    }
  }
}
</style>
